import { apiClient } from '@/to-fsd/shared/api';

export const rejectsService = {
  getRejectCases(params) {
    return apiClient.get('/merchant/credit/credits/reject-cases', { params });
  },
  approveRefund(id) {
    return apiClient.post(`/merchant/credit/credits/reject-cases/partner-approved/${id}`);
  },
  rejectRefund(id, payload) {
    return apiClient.post(`/merchant/credit/credits/reject-cases/partner-denied/${id}`, payload);
  },
};
